import {Routes} from '@angular/router';
import {AuthGuard} from './_global/auth/auth.guard';
import {HomeComponent} from './home/home.component';
import {
  HomeLoanComponent,
  BusinessAutoComponent,
  ConsumerAutoComponent,
  OnlineQuoteComponent,
  BrokerQuotesComponent,
} from './application/forms';
import {LogoutComponent} from './logout/logout.component';
import {LoginRouterComponent} from './_global/auth/login-router.component';
import {environment} from '../environments/environment';
import {MappingTestComponent} from './application/forms/mapping-test.component';
import {UnauthorizedComponent} from './_global/auth/unauthorized.component';
import {PartialResolverService} from './services/partial.resolver';
import {CanDeactivateGuard} from './_global/guards/can-deactivate.guard';

export const appRoutes: Routes = [
  {
    path: 'internal',
    component: LoginRouterComponent,
    data: {
      environment: environment.auth.internal
    }
  },
  {
    path: 'broker-car',
    component: LoginRouterComponent,
    data: {
      environment: environment.auth.brokerCar
    }
  },
  {
    path: 'broker-home',
    component: LoginRouterComponent,
    data: {
      environment: environment.auth.brokerHome
    }
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'mapper',
    component: MappingTestComponent
  },
  {
    path: 'application',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    resolve: {
      partial: PartialResolverService
    },
    children: [
      {path: 'home-loan', component: HomeLoanComponent, canDeactivate: [CanDeactivateGuard]},
      {path: 'consumer-auto', component: ConsumerAutoComponent, canDeactivate: [CanDeactivateGuard]},
      {path: 'personal-auto', component: ConsumerAutoComponent, canDeactivate: [CanDeactivateGuard]}
    ]
  },
  {path: '404', component: UnauthorizedComponent},
  {path: '**', redirectTo: '404'}
];
